import { normalize, parseExcel, guessColumns, importRows } from './pleading-engine.js';

export const PARTS = { order: 'أمر التنفيذ', efaa: 'مرفق إيفاء', pleading: 'اللائحة', common: 'المرفقات الموحدة', moeen: 'صور من معين' };
export const DEFAULT_ORDER = Object.keys(PARTS);
export const FINAL_PARTS = {order:PARTS.order,efaa:PARTS.efaa,pleading:PARTS.pleading,initial_judgment:'الحكم الابتدائي',final_judgment:'الحكم النهائي المختوم'};
export const FINAL_ORDER=Object.keys(FINAL_PARTS);
export function selectFinalTemplate(row,profile) {
  const evidence=normalize(row.fields.appeal_presence?.value);
  const number=normalize(row.fields.appeal_no?.value);
  const yes=['نعم','1','true','يوجد'].includes(evidence),no=['لا','0','false','لا يوجد','لايوجد'].includes(evidence);
  if(no&&number&&!/^0+$/.test(number))reject('تعارض: تم نفي الاستئناف مع وجود رقمه.');
  if(!yes&&!no&&(!number||/^0+$/.test(number)))reject('حدد وجود الاستئناف صراحة؛ غياب رقمه ليس إثباتًا لعدم وجوده.');
  if(!no&&(!number||/^0+$/.test(number)))row.fields.appeal_no={value:row.fields.unified_no.value,issues:[],candidates:[],derivedFrom:'unified_no'};
  return no?profile.finalNoAppealVersion:profile.finalVersion;
}
export const INPUT_FIELDS = { execution_no: 'رقم طلب التنفيذ', writ_no: 'رقم سند إيفاء', unified_no: 'رقم الدعوى الموحد' };
export function exactExcelIdentifier(cell) {
  if(!cell?.numeric||cell.formula)return cell;
  const raw=String(cell.value),m=raw.match(/^(\d+)(?:\.(\d+))?(?:[eE]\+?(\d+))?$/);
  if(!m)return cell;
  const fraction=m[2]||'',shift=Number(m[3]||0)-fraction.length;
  if(Math.abs(shift)>20)return cell;
  let digits=m[1]+fraction;
  if(shift<0){if(!/^0*$/.test(digits.slice(shift)))return cell;digits=digits.slice(0,shift)||'0';}
  else digits+='0'.repeat(shift);
  digits=digits.replace(/^0+(?=\d)/,'');
  if(digits.length>15)return cell;
  return {...cell,value:digits,numeric:false,originalValue:raw};
}
export function reject(message, status=422) { throw Object.assign(new Error(message), {status, code:'ADMIN_EXECUTION_INVALID'}); }
export function validateProfile(raw) {
  const name = String(raw.name || '').trim(), establishment = normalize(raw.establishment || '');
  if (!name || name.length > 180 || !/^7\d{9}$/.test(establishment)) reject('حدد اسم الشركة ورقم المنشأة المكون من 10 أرقام ويبدأ بـ7.');
  const order = raw.order || DEFAULT_ORDER;
  if (!Array.isArray(order) || order.length !== 5 || new Set(order).size !== 5 || order.some(x=>!PARTS[x])) reject('يجب أن يحتوي الترتيب كل المجموعات الخمس مرة واحدة.');
  const finalOrder=raw.finalOrder||FINAL_ORDER;
  if(!Array.isArray(finalOrder)||finalOrder.length!==5||new Set(finalOrder).size!==5||finalOrder.some(x=>!FINAL_PARTS[x]))reject('ترتيب الحكم النهائي يجب أن يحتوي مجموعاته الخمس مرة واحدة.');
  return {name, establishment, party:String(raw.party || '').trim().slice(0,2000), order,
    finalOrder,commercialNo:String(raw.commercialNo||'').trim().slice(0,30),executionChamber:String(raw.executionChamber||'').trim().slice(0,180),
    pendingVersion:String(raw.pendingVersion || '').slice(0,100), finalVersion:String(raw.finalVersion || '').slice(0,100),finalNoAppealVersion:String(raw.finalNoAppealVersion||'').slice(0,100)};
}
export function previewInput(bytes, options, profile) {
  const parsed = parseExcel(bytes, options), mapping = {...guessColumns(parsed.columns), ...options.mapping};
  if (!mapping.writ_no) mapping.writ_no = parsed.columns.find(x=>['رقم سند ايفاء','سند ايفاء','رقم سند','رقم السند'].includes(normalize(x))) || '';
  const aliases={execution_no:['امر التنفيذ'],writ_no:['رقم السند ايفاء'],opponent:['الامانه'],stage:['الحاله'],commercial_no:['رقم السجل']};
  const label=x=>normalize(x).replace(/[()]/g,'').replace(/\s+/g,' ').trim();
  for(const [key,names] of Object.entries(aliases))if(!mapping[key])mapping[key]=parsed.columns.find(c=>names.includes(label(c)))||'';
  for (const key of ['execution_no','unified_no']) if (!parsed.columns.includes(mapping[key])) return {columns:parsed.columns,mapping,needsMapping:true,rows:[],accepted:0};
  for(const source of parsed.rows)for(const [key,column] of Object.entries(mapping))if(key.endsWith('_no')&&source.cells[column])source.cells[column]=exactExcelIdentifier(source.cells[column]);
  const rows = importRows(parsed,mapping,'Excel التجهيز',{company:profile.name,party:profile.party,commercial_no:profile.commercialNo,execution_chamber:profile.executionChamber});
  for (const row of rows) {
    const issues=[],warnings=[];
    for(const key of ['execution_date','execution_hijri','execution_gregorian'])
      issues.push(...(row.fields[key]?.issues||[]));
    for (const [key,label] of Object.entries(INPUT_FIELDS)) {
      const cell=row.fields[key], value=normalize(cell?.value || '').replace(/[\u200e\u200f]/g,'');
      if(key==='writ_no'&&(!value||/^0+$/.test(value))&&!cell?.issues?.length){
        row.fields.writ_no={...cell,value:'',issues:[],candidates:[]};
        continue;
      }
      if (!/^\d{5,20}$/.test(value) || /^0+$/.test(value)) issues.push(`${label}: رقم غير صالح`);
      if (cell) cell.value=value;
      if (cell?.issues?.length) issues.push(...cell.issues);
    }
    if (normalize(row.fields.company?.value) !== normalize(profile.name)) issues.push('الشركة في الصف لا تطابق الشركة المختارة');
    const establishmentColumn=parsed.columns.find(x=>['رقم المنشاه','رقم منشاه'].includes(normalize(x)));
    const establishmentCell=parsed.rows.find(x=>`row-${x.row}`===row.id)?.cells[establishmentColumn];
    if(establishmentCell?.formula || (establishmentCell?.value && normalize(establishmentCell.value)!==profile.establishment)) issues.push('رقم المنشأة لا يطابق إعداد الشركة');
    let writ=row.fields.writ_no?.value;
    const payment=normalize(row.fields.payment_no?.value);
    if(writ&&writ===payment&&!row.fields.payment_no?.issues?.length){
      row.fields.writ_no={...row.fields.writ_no,value:'',originalValue:writ,derivedFrom:'payment_only'};
      writ='';
    }
    row.efaa={status:writ?'required':'not_applicable',reason:writ?'':row.fields.writ_no?.derivedFrom==='payment_only'?'payment_only':'no_writ_number'};
    if(!writ)warnings.push('لا يوجد سند إيفاء مستقل؛ المرفق متجاوز ويستخدم رقم السداد في موضع السند داخل اللائحة فقط');
    if(writ&&!/^1000\d{10}$/.test(writ))warnings.push('سند إيفاء خارج نمط العينة: 14 رقمًا تبدأ بـ1000؛ يحتاج مراجعة المصدر');
    if(!row.fields.case_no?.value||/^0+$/.test(row.fields.case_no.value))row.fields.case_no={value:row.fields.unified_no?.value||'',issues:[],candidates:[],derivedFrom:'unified_no'};
    row.issues=issues;row.warnings=warnings;
  }
  const groups=groupExecutionRows(rows);
  return {columns:parsed.columns,mapping,needsMapping:false,rows,groups,requestCount:groups.length,
    accepted:rows.filter(x=>!x.issues.length).length};
}

export function groupExecutionRows(rows) {
  const groups=new Map();
  for(const row of rows) {
    const key=normalize(row.fields.execution_no?.value || '');
    if(!groups.has(key))groups.set(key,{id:row.id,executionNumber:key,rows:[],issues:[]});
    groups.get(key).rows.push(row);
  }
  for(const group of groups.values()) {
    const identities=new Set();
    for(const row of group.rows) {
      const identity=JSON.stringify([row.fields.unified_no?.value || '',row.fields.violation_no?.value || '']);
      if(identities.has(identity))group.issues.push('تكرار الدعوى والمخالفة نفسهما داخل طلب التنفيذ؛ راجع الصفوف المتكررة');
      identities.add(identity);
    }
    const sharedFields={company:'الشركة',execution_date:'تاريخ أمر التنفيذ',execution_hijri:'تاريخ التنفيذ الهجري',execution_gregorian:'تاريخ التنفيذ الميلادي',payment_no:'رقم السداد',writ_no:'سند إيفاء'};
    for(const [field,label] of Object.entries(sharedFields)) {
      const values=new Set(group.rows.map(row=>normalize(row.fields[field]?.value || '')).filter(Boolean));
      if(values.size>1)group.issues.push(`بيانات طلب التنفيذ متعارضة: ${label}`);
    }
    // Missing shared identity is ambiguous: never silently query only the first row's writ.
    const writs=new Set(group.rows.map(row=>row.fields.writ_no?.value || ''));
    if(writs.size>1)group.issues.push('حالة سند إيفاء غير متفقة بين صفوف الطلب؛ ثبت السند المشترك أو عدم انطباقه');
    const payments=new Set(group.rows.map(row=>row.fields.payment_no?.value || ''));
    if(payments.size>1&&payments.has(''))group.issues.push('رقم السداد ناقص في بعض صفوف الطلب المشترك؛ استكمل الرقم من المصدر');
    group.issues=[...new Set(group.issues)];
    group.caseNumbers=[...new Set(group.rows.map(row=>row.fields.unified_no?.value).filter(Boolean))];
    group.violationNumbers=[...new Set(group.rows.map(row=>row.fields.violation_no?.value).filter(Boolean))];
    for(const row of group.rows) {
      row.issues.push(...group.issues);
      row.executionGroupSize=group.rows.length;row.executionCaseCount=group.caseNumbers.length;
    }
  }
  return [...groups.values()];
}
